import React, { PropTypes } from 'react'
import { SelectWrapper } from '../components/shared/select/SelectWrap'
import phoneCodes from './phoneCountryCodesSelect.json'
import { createFilter } from 'react-select'

const options = phoneCodes.map(({countryName, phoneCode}) => {
	const search = countryName.toLowerCase().split(/[^a-z]+/).join('|')
	return {
		value: `${phoneCode}`,
		label: ` ${phoneCode}`,
		search: `|${phoneCode}|${search}`,
	}
})

const matcher = filter => option => {
	const l = `|${filter.toLowerCase().replace(/[^a-z0-9]/, '|')}`
	return option.search.includes(l)
}

const filterConfig = {
  ignoreCase: true,
  ignoreAccents: true,
  trim: true,
  // matchFrom: 'start',
}

const filterOptions = (options, filter) => filter ? options.filter(matcher(filter)) : []

export const PhoneCountryCodesSelect = (props) => {

  return (
    <SelectWrapper
      {...props}
      isSearchable
      isClearable
      onBlur={() => props.onBlur()}
      options={options}
      filterOption={filterOptions}
    />
)}
PhoneCountryCodesSelect.propTypes = {
  onBlur: PropTypes.func,
}

export const CoutryPhoneCodesSelectCreatable = (props) => (
    <SelectWrapper
        {...props}
        placeholder=""
        options={options}
        isCreatable
        isClearable
        isSearchable
        isMulti={false}
        onBlur={() => props.onBlur()}
        onBlurResetsInput={false}
        formatCreateLabel={(value) => `${props.createLabel} ${value}`}
        filterOption={createFilter(filterConfig)}
        value={(props.value && props.value.value)}
        onChange={(value) => (props.onChangeOther(value))}
    />

)
CoutryPhoneCodesSelectCreatable.propTypes = {
    onBlur: PropTypes.func,
    createLabel: PropTypes.string,
    value: PropTypes.object,
    onChangeOther: PropTypes.func,
}

export const CoutryPhoneCodesInput = (props) => {

  return (
    <input
        {...props}
        type="text"
        className={props.className}
        onChange={props.onChange}
    />
)}
CoutryPhoneCodesInput.propTypes = {
    className: PropTypes.string,
    onChange: PropTypes.func,
}

export default PhoneCountryCodesSelect



// WEBPACK FOOTER //
// ./components/phoneCountryCodesSelect.jsx